/**
 * Tính toán một biểu thức toán học an toàn với các biến từ context
 *
 * Hàm này:
 * - Sanitize biểu thức bằng cách loại bỏ các ký tự nguy hiểm
 * - Tạo các biến từ context object
 * - Thực thi biểu thức trong một môi trường an toàn bằng Function constructor
 * - Xử lý lỗi và trả về 0 nếu tính toán thất bại
 *
 * @param {string} expr - Biểu thức toán học cần tính toán (ví dụ: "a + b * 2")
 * @param {Object} ctx - Object chứa các biến cần sử dụng trong biểu thức
 *                       (ví dụ: { a: 5, b: 10 })
 * @returns {number} Kết quả của phép tính hoặc 0 nếu có lỗi
 *
 * @example
 * // Tính toán: 5 + 10 * 2 = 25
 * createMathEval("a + b * 2", { a: 5, b: 10 }) // Returns: 25
 *
 * @example
 * // Tính toán với biểu thức sai sẽ trả về 0
 * createMathEval("a +++ b", { a: 5, b: 10 }) // Returns: 0
 */
export const createMathEval = (expr, ctx) => {
  const sanitized = expr.replace(/[^a-zA-Z0-9._+\-*/?():>=<!\\s]/g, '');
  const variables = Object.keys(ctx)
    .map(k => `const ${k} = ${JSON.stringify(ctx[k])};`)
    .join('');
  try {
    // eslint-disable-next-line no-new-func
    return new Function(variables + `return ${sanitized}`)();
  } catch (e) {
    console.warn(`Safe eval failed for "${expr}":`, e);
    return 0;
  }
};
